module.exports = __webpack_public_path__ + "img/news-color.f8a3606.svg";